import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TFacilityMembership } from "api/rpc/2024-04/facilityAdmin/membership/membership";

export type TGroupMembershipIncluded = {
  id: number;
  group_product_id: number;
  membership_id: number;
  quantity: number;
  sort_order: number;
  membership?: TFacilityMembership;
};

export type TGroupMembershipAddonMapping = {
  id: number;
  group_product_id: number;
  modifier_variant_id: number;
  membership_id: number;
  membership?: TFacilityMembership;
  modifier_variant?: { id?: number; title?: string };
};

export async function GetGroupMembershipConfig(
  params: { product_id: number },
  useGlobalLoader: boolean,
  token?: CancelToken,
  adminType: AdminType = AdminType.FacilityAdmin,
) {
  return await APIGet<{
    included: TGroupMembershipIncluded[];
    addon_mappings: TGroupMembershipAddonMapping[];
  }>(APIUrl(adminType, "/product/group-membership"), params, useGlobalLoader, token);
}

export async function PostGroupMembershipIncluded(
  params: { product_id: number; membership_id: number; quantity: number },
  useGlobalLoader: boolean,
  adminType: AdminType = AdminType.FacilityAdmin,
) {
  return await APIPost<TGroupMembershipIncluded>(
    APIUrl(adminType, "/product/group-membership"),
    params,
    useGlobalLoader,
  );
}

export async function PutGroupMembershipIncluded(
  params: { id: number; quantity: number },
  useGlobalLoader: boolean,
  adminType: AdminType = AdminType.FacilityAdmin,
) {
  return await APIPut<TGroupMembershipIncluded>(
    APIUrl(adminType, "/product/group-membership"),
    params,
    useGlobalLoader,
  );
}

export async function DeleteGroupMembershipIncluded(
  params: { id: number },
  useGlobalLoader: boolean,
  adminType: AdminType = AdminType.FacilityAdmin,
) {
  return await APIDelete(APIUrl(adminType, "/product/group-membership"), params, useGlobalLoader);
}

export async function PostGroupMembershipAddon(
  params: { product_id: number; modifier_variant_id: number; membership_id: number },
  useGlobalLoader: boolean,
  adminType: AdminType = AdminType.FacilityAdmin,
) {
  return await APIPost<TGroupMembershipAddonMapping>(
    APIUrl(adminType, "/product/group-membership/addon"),
    params,
    useGlobalLoader,
  );
}

export async function DeleteGroupMembershipAddon(
  params: { id: number },
  useGlobalLoader: boolean,
  adminType: AdminType = AdminType.FacilityAdmin,
) {
  return await APIDelete(APIUrl(adminType, "/product/group-membership/addon"), params, useGlobalLoader);
}
